// PDF generation, image conversion, and content-hash helpers.

import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { Md5 } from 'ts-md5';

export async function generatePDF(nativeElement: any): Promise<void> {
  const DATA = nativeElement;
  try {
    const canvas = await html2canvas(DATA, { scale: 2 }); // Adjust the scale to reduce resolution
    const imgWidth = 208;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    const contentDataURL = canvas.toDataURL('image/jpeg', 0.75); // Use JPEG format and reduce quality
    const pdf = new jsPDF('p', 'mm', 'a4');
    const position = 0;
    pdf.addImage(
      contentDataURL,
      'JPEG',
      0,
      position,
      imgWidth,
      imgHeight,
      undefined,
      'FAST',
    ); // Use 'FAST' compression
    pdf.save('sales-receipt.pdf');
  } catch (error) {
    console.error('Error generating PDF:', error);
  }
}

export function convertImageToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result as string);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function createMd5Hash(data: any): string {
  return Md5.hashStr(data);
}
